import { TierLevels } from 'types/session/user'

export enum SpaceMLYGenericEvents {
	IMPRESSION_MLY = 'impression_mly',
	CLICK_MLY = 'click_mly',
}

export enum ClickMLYActions {
	WELCOME_MESSAGE = 'welcome_message_ok',
	HISTORY = 'show_history',
	UNLOCK_EXPERIENCE = 'unlock_experience',
	UNLOCK_NON_PROFIT = 'unlock_donation',
	SHOW_EXPERIENCE = 'show_experience',
	SHOW_DONATION = 'show_donation',
	YOUR_ADVANTAGES = 'your_advantages',
	UNLOCK_ADVANTAGES = 'unlock_advantages',
	HELP_SEE_MORE = 'help_see_more',
}

export enum ImpressionMLYActions {
	WELCOME_MESSAGE = 'welcome_message',
	SHOW_EXPERIENCE = 'show_experience',
	SHOW_DONATION = 'show_donation',
}

export const TIER_LEVELS_EVENT_TYPE: Record<TierLevels, string> = {
	[TierLevels.TIER_1]: 'member',
	[TierLevels.TIER_2]: 'classic',
	[TierLevels.TIER_3]: 'iconic',
}
